import React from 'react'

import { numSpaces } from '../../../utils/functions';

import './HistoryTable.scss'

const prepDate = ts => {
  const date = new Date(ts)
  const d = date.getDate()
  const m = date.getMonth()
  const y = date.getFullYear()

  return `${ d < 10 ? 0 : '' }${ d }/${ m < 10 ? 0 : '' }${ m }/${ y }`
}

export const HistoryTable = ({ list }) => {

  const rows = []
  for (let i = 0; i < list.length; i++) {
    if (!list[i]) break;
    
    const { event, payer, price, timestamp } = list[i]
    rows.push(
      <div key={ i } className="row-item">
        <span>
          { event }
        </span>
        <span>
          { payer ? payer.substr(0, 7) : '-' }
        </span>
        <span>
          { price ? `${ numSpaces(price / 1000000) } TRX` : '-' }
        </span>
        <span>
          { prepDate(timestamp) }
        </span>
      </div>
    )
  }

  return (
    <div className="history-table-container">
      <div className="rows-wrapper">
        <div className="row-item">
          <span>
            TYPE
          </span>
          <span>
            FROM
          </span>
          <span>
            AMOUNT
          </span>
          <span>
            TNX
          </span>
        </div>
        { rows }
      </div>
    </div>
  )
}